import LandingHeader from '../components/landing/LandingHeader'
import HeroSection from '../components/landing/HeroSection'
import SolutionSection from '../components/landing/SolutionSection'
import BenefitsSection from '../components/landing/BenefitsSection'
import StatsSection from '../components/landing/StatsSection'
import FeaturesSection from '../components/landing/FeaturesSection'
import TestimonialsSection from '../components/landing/TestimonialsSection'
import FAQSection from '../components/landing/FAQSection'
import ContactSection from '../components/landing/ContactSection'
import LandingFooter from '../components/landing/LandingFooter'

const LandingPage = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <LandingHeader />
      <main>
        <HeroSection />
        <SolutionSection />
        <BenefitsSection />
        <StatsSection />
        <FeaturesSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <LandingFooter />
    </div>
  )
}

export default LandingPage

